import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import {
  CollapsibleApplicantProfile,
} from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import {
  ApplicantUserCitizenship,
  ApplicantUserContactInformation,
  ApplicantUserIdentityDetails,
  ApplicantUserProfessional,
  CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Document,
  Entity,
} from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { lookupCountryQuery } from './identity-verification-v1-country-query'
import { Country } from "../../../../../../types/country";

interface CollapsibleApplicantProfileContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileContainer: React.FC<
  CollapsibleApplicantProfileContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Document,
    {
      variables: {
        identityVerificationCaseV1Id: props.caseId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          showAccountEstablishmentAttestation ={true}
          professional={applicantDetailData?.identityVerificationCaseV1?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.identityVerificationCaseV1?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.identityVerificationCaseV1?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.identityVerificationCaseV1?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.identityVerificationCaseV1?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
